/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { headers, setupInterceptorsTo } from "./interceptors"
import { getMeditToken, getMeditCaselist, getMeditGroupUuid } from './httpMedit'
import {
  get3ShapeToken,
  get3ShapeCaselist,
  get3ShapeCaseById,
  downloadScan,
  refreshToken,
  save3ShapeFileTest,
  search
} from "./http3Shape"
import {getPatientslist, getAlliedCaselist, getAlliedCaseDetail, downloadAlliedStarFilesbyName, downloadAlliedStarFilesbyFormat} from "./httpAlliedstar"
import { registerDefaultData } from "@jsonforms/core"

const { VITE_DOMAIN } = import.meta.env

type TypeParams = {
  type: '3Shape' | 'Medit' | 'Alliedstar';
  id?:string;
  page?: number; 
  size?: number;
  name?: string; // for search
};

interface DataItem {
  Attachments: any[];  
  Scans: any[];  
  Info: { CaseId: string; PatientName: string; CreateTime: string, FirstName: string; LastName: string }; //Record<string, unknown>; 
}

function stringToArrayBuffer(str: string): ArrayBuffer {
  const buf = new ArrayBuffer(str.length)
  const bufView = new Uint8Array(buf)
  for (let i = 0; i < str.length; i++) {
    bufView[i] = str.charCodeAt(i)
  }
  return buf
}

function saveBlobToFile(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // 设置下载文件名
  document.body.appendChild(a);
  a.click(); // 触发下载
  document.body.removeChild(a); // 移除元素
  URL.revokeObjectURL(url); // 释放内存
}

// return [{Attachments:[],Scans:[],Info:{}}, .....]
// if 3shpae , attachments and scans have values, others null array
export async function  getCaseList<T = any>(
    param: TypeParams,
  ) {
    
    try {
        if (param.type === '3Shape') {  
            //save3ShapeFileTest()
            if (param.name === ""){
              return get3ShapeCaselist(param.page.toString())
            }
            else {
              // search by name
              return search(param.name, param.page.toString())
            }
            
        } else if (param.type === 'Medit') {
          //getMeditGroupUuid()  
          return getMeditCaselist(param.page, 10, param.name)
        } else if (param.type === 'Alliedstar') {
            //downloadAlliedStarFilesbyFormat('250528013578541744128',['stl'])
           // const ret = await getAlliedCaseDetail('250528013578541744128')console.log("dddd===", ret.data.data)
           return getAlliedCaselist(param.page, param.name)
            
        }
    } catch (error) {
      
      console.error("getCaseList failed:", error)
      throw error
    }

  }

export async function  getCaseDetail<T = any>(
    param: TypeParams
  ){
    try {
        if (param.type === 'Medit') {
        
        } 
        else if (param.type === 'Alliedstar') {
            // return attachments array
            const ret = await getAlliedCaseDetail(param.id)
            return ret.data.data
        }
    } catch (error) {
      
      console.error("getCaseDetail failed:", error)
      throw error
    }
  }

export async function  getCaseFile<T = any>(
    param: TypeParams,
    fileURL ?: string,
    caseCode ?:string,
    filesName ?:string[]
  ){
    try {
        if (param.type === 'Medit') {
        
        } 
    } catch (error) {
      
      console.error("getCaseFile failed:", error)
      throw error
    }
  }
